import {useUserAdminService} from '../../../controllers/DashboardServiceController'
import {NewPassword} from './NewPassword'

export default function NewCustomerPassword() {
    const userAdminService = useUserAdminService()
    return <NewPassword setPassword={userAdminService.resetMemberPassword} heading={'New customer password'}/>
}
